import React from 'react';
import './Banner.scss';

function Banner() {
  return (
    <div className="banner">
      Coming up ....
    </div>
  );
}

export default Banner;
